export const getInitials = (name: string): string => {
  const parts = name.split(" ").filter(Boolean);

  if (parts.length === 0) return "?";

  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();

  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};
